import { useLightMode } from '@/hooks/useLightMode'

import { AudioPlayer } from '@hivewatch/dark'

import { Notification } from '@/graphql/appsync-notifications'
import { useNotificationAudioMessagesQuery } from '@/graphql/generated/hooks'

import { getNotificationToastTokens } from '../styles/tokens'
import { AudioNotificationTitle } from './AudioNotificationTitle'
import { NotificationSubtitle } from './NotificationSubtitle'
import { NotificationToastShell } from './NotificationToastShell'

export const AudioNotification = ({
  notification,
  onCancel,
}: {
  notification: Notification
  onCancel?: (incidentTimeStamp: string) => void
}) => {
  const colorScheme = useLightMode()
  const tokens = getNotificationToastTokens(colorScheme)
  const { data } = useNotificationAudioMessagesQuery({
    variables: {
      id: notification.audioMessageId,
    },
  })

  const url = data?.audioMessages?.edges?.[0]?.node?.audioClip?.url

  return (
    <NotificationToastShell
      accentColor={tokens.danger}
      height='120px'
      notificationTimestamp={notification?.notificationTimestamp}
      onCancel={onCancel}
    >
      <AudioNotificationTitle notification={notification} />
      <NotificationSubtitle
        facilityShortName={notification?.facilityShortName}
        sourceName={notification?.incidentSourceName}
        timestamp={notification?.notificationTimestamp}
      />
      {url && <AudioPlayer colorScheme={colorScheme} url={url} />}
    </NotificationToastShell>
  )
}
